
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const reportData = {
  customer: {
    name: '张伟',
    avatar: 'https://public.readdy.ai/ai/img_res/874f9bb8435f838f38bdb84adc219170.jpg',
    riskLevel: '稳健型',
    totalAssets: '286.5万',
  },
  period: '2024年12月',
  generatedAt: '2025-01-15 09:32',
  sections: [
    {
      title: '账户概览',
      icon: 'ri-pie-chart-2',
      content: [
        { label: '期初资产', value: '275.8万' },
        { label: '期末资产', value: '286.5万' },
        { label: '本期收益', value: '+10.7万', highlight: true, positive: true },
        { label: '收益率', value: '+3.88%', highlight: true, positive: true },
        { label: '同期沪深300', value: '+1.25%' },
        { label: '超额收益', value: '+2.63%', highlight: true, positive: true },
      ],
    },
    {
      title: '持仓分析',
      icon: 'ri-donut-chart',
      holdings: [
        { name: '股票型基金', ratio: 45, amount: '128.9万', change: '+5.2%' },
        { name: '债券型基金', ratio: 30, amount: '86.0万', change: '+1.1%' },
        { name: '货币基金', ratio: 15, amount: '43.0万', change: '+0.2%' },
        { name: '混合型基金', ratio: 10, amount: '28.6万', change: '+3.8%' },
      ],
    },
    {
      title: '交易回顾',
      icon: 'ri-exchange-funds',
      trades: [
        { date: '12-05', type: 'buy', name: '易方达蓝筹精选', amount: '20万', reason: '低位加仓' },
        { date: '12-12', type: 'sell', name: '招商中证白酒', amount: '15万', reason: '止盈减仓' },
        { date: '12-18', type: 'buy', name: '华夏科技创新', amount: '10万', reason: '板块轮动' },
        { date: '12-25', type: 'switch', name: '债基转货基', amount: '30万', reason: '年末避险' },
      ],
    },
    {
      title: '风险评估',
      icon: 'ri-shield-check',
      risks: [
        { name: '波动率', value: '12.5%', status: 'normal', desc: '低于同类平均' },
        { name: '最大回撤', value: '-3.2%', status: 'normal', desc: '控制良好' },
        { name: '夏普比率', value: '1.85', status: 'good', desc: '风险收益优秀' },
        { name: '集中度', value: '中等', status: 'warning', desc: '建议适度分散' },
      ],
    },
    {
      title: '下期建议',
      icon: 'ri-lightbulb',
      suggestions: [
        { priority: 'high', text: '建议增配港股科技ETF，把握估值修复机会' },
        { priority: 'medium', text: '债券仓位可适度提升至35%，应对市场波动' },
        { priority: 'medium', text: '关注新能源板块回调后的布局机会' },
        { priority: 'low', text: '货币基金可转换为短债基金提升收益' },
      ],
    },
  ],
};

export default function ReportDetailPage() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = (type: string) => {
    setShowShareMenu(false);
    // 模拟分享操作
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* 顶部导航 */}
      <div className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md z-50 px-4 py-3 flex items-center justify-between border-b border-gray-100">
        <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-left-line text-xl text-gray-700"></i>
        </button>
        <span className="text-base font-semibold text-gray-800">账户复盘报告</span>
        <button onClick={() => setShowShareMenu(true)} className="w-8 h-8 flex items-center justify-center">
          <i className="ri-share-forward-line text-xl text-gray-700"></i>
        </button>
      </div>

      <div className="pt-16 px-4">
        {/* 客户信息卡片 */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-4 mt-3 text-white">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={reportData.customer.avatar}
              alt={reportData.customer.name}
              className="w-12 h-12 rounded-full border-2 border-white/30 object-cover"
            />
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-lg">{reportData.customer.name}</span>
                <span className="text-xs bg-white/20 px-2 py-0.5 rounded-full">{reportData.customer.riskLevel}</span>
              </div>
              <div className="text-sm text-blue-100 mt-0.5">总资产 {reportData.customer.totalAssets}</div>
            </div>
          </div>
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-1.5 text-blue-100">
              <i className="ri-calendar-line"></i>
              <span>报告周期：{reportData.period}</span>
            </div>
            <div className="flex items-center gap-1.5 text-blue-100">
              <i className="ri-time-line"></i>
              <span>{reportData.generatedAt}</span>
            </div>
          </div>
        </div>

        {/* 账户概览 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-blue-50 rounded-lg">
              <i className="ri-pie-chart-2-line text-blue-600"></i>
            </div>
            <span className="font-semibold text-gray-800">账户概览</span>
          </div>
          <div className="grid grid-cols-3 gap-3">
            {reportData.sections[0].content.map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-3 text-center">
                <div className="text-xs text-gray-500 mb-1">{item.label}</div>
                <div className={`text-sm font-semibold ${item.highlight ? (item.positive ? 'text-red-500' : 'text-green-500') : 'text-gray-800'}`}>
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 持仓分析 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-purple-50 rounded-lg">
              <i className="ri-donut-chart-line text-purple-600"></i>
            </div>
            <span className="font-semibold text-gray-800">持仓分析</span>
          </div>
          <div className="space-y-3">
            {reportData.sections[1].holdings?.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm text-gray-700">{item.name}</span>
                    <span className="text-xs text-gray-500">{item.amount}</span>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full ${
                        index === 0 ? 'bg-blue-500' : index === 1 ? 'bg-purple-500' : index === 2 ? 'bg-green-500' : 'bg-orange-500'
                      }`}
                      style={{ width: `${item.ratio}%` }}
                    ></div>
                  </div>
                </div>
                <div className="w-14 text-right">
                  <span className={`text-sm font-medium ${parseFloat(item.change) > 0 ? 'text-red-500' : 'text-green-500'}`}>
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 交易回顾 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-lg">
              <i className="ri-exchange-funds-line text-green-600"></i>
            </div>
            <span className="font-semibold text-gray-800">交易回顾</span>
          </div>
          <div className="space-y-3">
            {reportData.sections[2].trades?.map((trade, index) => (
              <div key={index} className="flex items-start gap-3 pb-3 border-b border-gray-50 last:border-0 last:pb-0">
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                  trade.type === 'buy' ? 'bg-red-50' : trade.type === 'sell' ? 'bg-green-50' : 'bg-blue-50'
                }`}>
                  <i className={`${
                    trade.type === 'buy' ? 'ri-add-line text-red-500' : trade.type === 'sell' ? 'ri-subtract-line text-green-500' : 'ri-arrow-left-right-line text-blue-500'
                  }`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-800">{trade.name}</span>
                    <span className={`text-sm font-medium ${trade.type === 'buy' ? 'text-red-500' : trade.type === 'sell' ? 'text-green-500' : 'text-blue-500'}`}>
                      {trade.type === 'buy' ? '+' : trade.type === 'sell' ? '-' : ''}{trade.amount}
                    </span>
                  </div>
                  <div className="flex items-center justify-between mt-1">
                    <span className="text-xs text-gray-400">{trade.date}</span>
                    <span className="text-xs text-gray-500 bg-gray-50 px-2 py-0.5 rounded">{trade.reason}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 风险评估 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-orange-50 rounded-lg">
              <i className="ri-shield-check-line text-orange-600"></i>
            </div>
            <span className="font-semibold text-gray-800">风险评估</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {reportData.sections[3].risks?.map((risk, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-3">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-gray-500">{risk.name}</span>
                  <div className={`w-2 h-2 rounded-full ${
                    risk.status === 'good' ? 'bg-green-500' : risk.status === 'normal' ? 'bg-blue-500' : 'bg-orange-500'
                  }`}></div>
                </div>
                <div className="text-base font-semibold text-gray-800">{risk.value}</div>
                <div className="text-xs text-gray-400 mt-0.5">{risk.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 下期建议 */}
        <div className="bg-white rounded-2xl p-4 mt-4 shadow-sm">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 flex items-center justify-center bg-yellow-50 rounded-lg">
              <i className="ri-lightbulb-line text-yellow-600"></i>
            </div>
            <span className="font-semibold text-gray-800">下期建议</span>
          </div>
          <div className="space-y-3">
            {reportData.sections[4].suggestions?.map((suggestion, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className={`w-5 h-5 flex items-center justify-center rounded-full mt-0.5 ${
                  suggestion.priority === 'high' ? 'bg-red-100' : suggestion.priority === 'medium' ? 'bg-orange-100' : 'bg-gray-100'
                }`}>
                  <i className={`ri-arrow-up-line text-xs ${
                    suggestion.priority === 'high' ? 'text-red-500' : suggestion.priority === 'medium' ? 'text-orange-500' : 'text-gray-400'
                  }`}></i>
                </div>
                <p className="flex-1 text-sm text-gray-700 leading-relaxed">{suggestion.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* AI 总结 */}
        <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl p-4 mt-4 border border-indigo-100">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 flex items-center justify-center bg-indigo-100 rounded-lg">
              <i className="ri-robot-line text-indigo-600"></i>
            </div>
            <span className="font-semibold text-gray-800">AI 总结</span>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            张伟先生本月账户表现优异，收益率+3.88%，跑赢沪深300指数2.63个百分点。资产配置较为均衡，风险控制良好，最大回撤仅-3.2%。建议下月关注港股科技板块的估值修复机会，同时适度提升债券仓位以应对潜在市场波动。整体投资策略符合稳健型风险偏好，继续保持当前配置思路。
          </p>
        </div>
      </div>

      {/* 底部操作栏 */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 py-3 flex gap-3">
        <button
          onClick={handleCopy}
          className="flex-1 h-11 bg-gray-100 rounded-xl flex items-center justify-center gap-2 text-gray-700"
        >
          <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'}`}></i>
          <span className="text-sm font-medium">{copied ? '已复制' : '复制报告'}</span>
        </button>
        <button
          onClick={() => setShowShareMenu(true)}
          className="flex-1 h-11 bg-blue-600 rounded-xl flex items-center justify-center gap-2 text-white"
        >
          <i className="ri-send-plane-fill"></i>
          <span className="text-sm font-medium">发送客户</span>
        </button>
      </div>

      {/* 分享菜单 */}
      {showShareMenu && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end" onClick={() => setShowShareMenu(false)}>
          <div className="w-full bg-white rounded-t-3xl p-4 pb-8" onClick={(e) => e.stopPropagation()}>
            <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-4"></div>
            <h3 className="text-base font-semibold text-gray-800 text-center mb-4">发送报告给客户</h3>
            <div className="grid grid-cols-4 gap-4">
              <button onClick={() => handleShare('wechat')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-xl">
                  <i className="ri-wechat-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">微信</span>
              </button>
              <button onClick={() => handleShare('enterprise')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-500 rounded-xl">
                  <i className="ri-building-line text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">企业微信</span>
              </button>
              <button onClick={() => handleShare('sms')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl">
                  <i className="ri-message-2-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">短信</span>
              </button>
              <button onClick={() => handleShare('email')} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center bg-purple-500 rounded-xl">
                  <i className="ri-mail-fill text-2xl text-white"></i>
                </div>
                <span className="text-xs text-gray-600">邮件</span>
              </button>
            </div>
            <button
              onClick={() => setShowShareMenu(false)}
              className="w-full h-11 bg-gray-100 rounded-xl mt-6 text-gray-600 font-medium"
            >
              取消
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
